import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VRow,
    { attrs: { dense: "" } },
    [
      _c(
        VCol,
        { attrs: { cols: "12" } },
        [_c("app-title", { attrs: { texto: _vm.titulo.toUpperCase() } })],
        1
      ),
      _c(
        VCol,
        { attrs: { cols: "12" } },
        [
          _c(VDataTable, {
            staticClass: "elevation-0",
            attrs: {
              items: _vm.diagnosticosView,
              headers: _vm.headers,
              search: _vm.opcoes.pesquisa,
              "sort-by": _vm.opcoes.ordenarPor,
              "sort-desc": _vm.opcoes.decrescente,
              "item-key": "id",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "top",
                  fn: function () {
                    return [
                      _c(
                        VRow,
                        { attrs: { dense: "" } },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("app-sort", {
                                model: {
                                  value: _vm.opcoes,
                                  callback: function ($$v) {
                                    _vm.opcoes = $$v
                                  },
                                  expression: "opcoes",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(VCol, { attrs: { cols: "0", md: "4" } }),
                          _c(
                            VCol,
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("app-search", {
                                model: {
                                  value: _vm.opcoes,
                                  callback: function ($$v) {
                                    _vm.opcoes = $$v
                                  },
                                  expression: "opcoes",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: `item.inicioDesempenho`,
                  fn: function ({ item }) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("date")(item.inicioDesempenho)) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: `item.situacao`,
                  fn: function ({ item }) {
                    return [
                      _c(
                        VChip,
                        {
                          staticClass: "pa-2",
                          attrs: {
                            color: item.situacao.cor,
                            small: "",
                            outlined: "",
                          },
                        },
                        [
                          _c(
                            VAvatar,
                            { attrs: { left: "" } },
                            [
                              _c(VIcon, [
                                _vm._v(_vm._s(item.situacao.icone)),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" " + _vm._s(item.situacao.nome) + " "),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: `item.acoes`,
                  fn: function ({ item }) {
                    return [
                      _c(
                        VCol,
                        [
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    item.situacao.id ===
                                                      "AGENDADO" ||
                                                    item.situacao.id ===
                                                      "ATIVO",
                                                  expression:
                                                    "item.situacao.id === 'AGENDADO' || item.situacao.id === 'ATIVO'",
                                                },
                                              ],
                                              staticClass: "mr-2",
                                              attrs: {
                                                icon: "",
                                                small: "",
                                                color: "secondary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editar(item)
                                                },
                                              },
                                            },
                                            on
                                          ),
                                          [_c(VIcon, [_vm._v("edit")])],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Clique no botão para editar o diagnóstico"
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    item.situacao.id ===
                                                    "AGENDADO",
                                                  expression:
                                                    "item.situacao.id === 'AGENDADO'",
                                                },
                                              ],
                                              attrs: {
                                                icon: "",
                                                small: "",
                                                color: "error",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.confirmDelete(item)
                                                },
                                              },
                                            },
                                            on
                                          ),
                                          [_c(VIcon, [_vm._v("delete")])],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Clique no botão para excluir o diagnóstico"
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c("dialog-remove", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.dialogs.dialogRemove.visible,
            expression: "dialogs.dialogRemove.visible",
          },
        ],
        attrs: {
          "confirm-action": _vm.deleteDiagnostico,
          "dialog-visible": _vm.dialogs.dialogRemove.visible,
          "toogle-visible": _vm.toogleDialogRemove,
          descricao: "Você realmente deseja excluir esse diagnóstico",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }